module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="btn-end-step btn-back"></div>\n<div class="edit-actions">\n  <button class="save-changes btn btn-large btn-primary">Save changes</button>\n  <div class="loader">Loading...</div>\n  <a class="btn-end-step cancel-action" href="#"\n    onclick="return false;">Cancel</a>\n</div>\n';

}
return __p
}